import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ImagePreviewPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { generatedImage, pet } = location.state || {}; // Get data passed from the previous page

    if (!generatedImage || !pet) {
        return (
            <div>
                <p>No image to preview. Please generate an image first.</p>
                <button onClick={() => navigate(-1)}>Go Back</button>
            </div>
        );
    }

    const downloadImage = () => {
        const link = document.createElement('a');
        link.href = generatedImage;
        link.download = `${pet.name}-lost-pet.png`;
        link.click();
    };


    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>Preview Image</h1>
            <img
                src={generatedImage}
                alt="Generated Preview"
                style={{ width: '300px', border: '1px solid #ccc', marginBottom: '20px' }}
            />
            <div>
                <button
                    onClick={downloadImage}
                    style={{
                        marginRight: '10px',
                        padding: '10px 20px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                    }}
                >
                    Download Image
                </button>
            </div>
        </div>
    );
};

export default ImagePreviewPage;